import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'save-menu {{if this.isOpen \"is-open\"}}\' ...attributes>\n  <button\n    type=\'button\'\n    class=\'button success save-menu-primary {{if @running \"loading\"}}\'\n    disabled={{this.isDisabled}}\n    data-test-save\n    {{on \'click\' this.save}}\n    {{on-key \'ctrl+s\'}}\n  >\n    <span>\n      {{#if @saveLabel}}\n        {{@saveLabel}}\n      {{else}}\n        {{t \'save\'}}\n      {{/if}}\n    </span>\n  </button>\n\n  {{#if @onSaveNew}}\n    <button\n      type=\'button\'\n      class=\'button success save-menu-toggle\'\n      aria-haspopup=\'menu\'\n      aria-expanded=\'{{if this.isOpen \"true\" \"false\"}}\'\n      aria-label={{t \'save and new\'}}\n      disabled={{this.isDisabled}}\n      data-test-bb-save-menu-toggle\n      {{on \'click\' this.toggle}}\n    >\n      <FaIcon @icon=\'chevron-up\' />\n    </button>\n\n    {{#if this.isOpen}}\n      <button\n        type=\'button\'\n        class=\'save-menu-backdrop\'\n        aria-hidden=\'true\'\n        tabindex=\'-1\'\n        data-test-bb-save-menu-close\n        {{on \'click\' this.close}}\n        {{on-key \'Escape\'}}\n      ></button>\n      <div class=\'save-menu-pane\' role=\'menu\'>\n        <button\n          type=\'button\'\n          class=\'save-menu-item\'\n          role=\'menuitem\'\n          data-test-save-new\n          {{on \'click\' this.saveNew}}\n        >\n          {{#if @saveNewLabel}}\n            {{@saveNewLabel}}\n          {{else}}\n            {{t \'save and new\'}}\n          {{/if}}\n        </button>\n      </div>\n    {{/if}}\n  {{/if}}\n</div>");

var _class, _descriptor;
let BbSaveMenuComponent = (_class = class BbSaveMenuComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isOpen", _descriptor, this);
  }
  get isDisabled() {
    return !!this.args.disabled || !!this.args.running;
  }
  toggle() {
    if (this.isDisabled) {
      return;
    }
    this.isOpen = !this.isOpen;
  }
  close() {
    this.isOpen = false;
  }
  save() {
    this.close();
    this.args.onSave?.();
  }
  saveNew() {
    this.close();
    this.args.onSaveNew?.();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "toggle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveNew", [action], Object.getOwnPropertyDescriptor(_class.prototype, "saveNew"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbSaveMenuComponent);

export { BbSaveMenuComponent as default };
//# sourceMappingURL=bb-save-menu.js.map
